export default __webpack_public_path__ + "static/media/blog-post.fb30a9b0.png";